export default "__VITE_ASSET__nvZwO_A0__"